import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

const TUTORCAT_APP_STORE_URL = 'https://apps.apple.com/pk/app/tutorcat-ai-homework-help/id6504099216'
const SHARE_FOOTER = `Solved with TutorCat — AI Homework Help 📚 ${TUTORCAT_APP_STORE_URL}`

export const stripMarkdown = (markdown: string): string => {
	return markdown
		.replace(/^###\s+/gm, '')
		.replace(/^##\s+/gm, '')
		.replace(/^#\s+/gm, '')
		.replace(/\*\*/g, '')
		.replace(/\*/g, '')
		.replace(/`/g, '')
		.replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
		.trim()
}

export const prepareShareContent = (answerText: string): string => {
	const plainText = stripMarkdown(answerText)
	return `${plainText}\n\n${SHARE_FOOTER}`
}
